// extracted by mini-css-extract-plugin
export default {"base":"Reinstall_base__cakB9","base__left":"Reinstall_base__left__C2Pgb","base__right":"Reinstall_base__right__xoFKi"};